import React from 'react'
import { Link } from 'react-router'
import { firebaseRef } from '../utils/firebase'
import ReactGA from 'react-ga'

class Signup extends React.Component {

  constructor() {
    super();
    this.state = {
      emailAddress: "",
      hasSignup: false
    }
  }

  onChange = (event) => {
    this.setState({ emailAddress: event.target.value });
  }

  onSignup = (event) => {
    event.preventDefault();
    const emailEl = this.refs["email"];
    const messageEl = this.refs["message"];

    ReactGA.event({
      category: 'Forms',
      action: 'SIGN_UP',
      value: 1
    });

    firebaseRef.database().ref('signups/').push({
      email: emailEl.value
    }, (error) => {
      if (error) {
        messageEl.innerHTML = 'Sorry, something went wrong. Please try again.';
      } else {
        messageEl.innerHTML = 'Thanks! We will be in touch soon.';
      }
    });

    this.setState({ hasSignup: true });
  }

  maybeRenderPlaceholder() {
    return this.state.emailAddress.length === 0 ? (
      <div className="faux-placeholder">Email address</div>
    ) : null
  }

  render () {
    const { emailAddress, hasSignup } = this.state;
    const { text } = this.props;
    return (
      <form className="form" id="signup" onSubmit={this.onSignup}>
        <p>{text}</p>
        <fieldset className="fieldset">
          {this.maybeRenderPlaceholder()}
          <div className={`${hasSignup ? 'hidden' : ''} fields`}>
            <input
                type="email"
                ref="email"
                className="email"
                onChange={this.onChange}
                value={emailAddress}
                required/>
            <button className="go">Sign Up</button>
          </div>
          <div ref="message" className={`${hasSignup ? '' : 'hidden'} message`}></div>
        </fieldset>
      </form>
    )
  }
}

export default Signup



// WEBPACK FOOTER //
// ../components/Signup.js